import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { BulkEntryGrid } from '../components/BulkEntryGrid';
import { useCompany } from '../contexts/CompanyContext';
import api from '../lib/api';
import { toast } from 'sonner';
import { ArrowLeft, Truck } from 'lucide-react';

const BulkSuppliers = () => {
  const navigate = useNavigate();
  const { activeCompany } = useCompany();
  const [sharedDefaults, setSharedDefaults] = useState({ city: '' });

  const columns = useMemo(() => [
    { key: 'name', label: 'Supplier Name', required: true, placeholder: 'Enter name', width: '200px', sharedDefault: false },
    { key: 'city', label: 'City', required: true, placeholder: 'Enter city', width: '140px', sharedDefault: true,
      onSharedChange: (d) => setSharedDefaults(prev => ({ ...prev, city: d.city }))
    },
    { key: 'contact_person', label: 'Contact Person', placeholder: 'Name', width: '160px' },
    { key: 'phone', label: 'Phone', placeholder: '9876543210', width: '130px' },
    { key: 'email', label: 'Email', placeholder: 'email@example.com', width: '180px' },
    { key: 'gstin', label: 'GSTIN', placeholder: 'GSTIN number', width: '160px' },
    { key: 'address', label: 'Address', placeholder: 'Address', width: '200px' },
  ], []);

  const handleSave = async (rows) => {
    const res = await api.post('/bulk/suppliers', { rows });
    if (res.data.success_count > 0) {
      toast.success(`${res.data.success_count} supplier(s) created successfully`);
    }
    if (res.data.error_count > 0) {
      toast.error(`${res.data.error_count} row(s) had errors`);
    }
    return res.data;
  };

  return (
    <div className="space-y-6" data-testid="bulk-suppliers-page">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Button variant="ghost" size="icon" onClick={() => navigate(-1)} data-testid="bulk-suppliers-back">
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <div>
            <h1 className="text-2xl font-bold text-slate-900" style={{ fontFamily: 'Manrope' }}>Bulk Add Suppliers</h1>
            <p className="text-sm text-slate-500 mt-0.5">
              Add multiple suppliers at once · <span className="theme-text font-medium">{activeCompany?.name}</span>
            </p>
          </div>
        </div>
        <Button variant="outline" size="sm" onClick={() => navigate('/masters')} className="gap-1.5">
          <Truck className="h-4 w-4" /> View Masters
        </Button>
      </div>

      <Card>
        <CardContent className="p-6">
          <BulkEntryGrid
            columns={columns}
            sharedDefaults={sharedDefaults}
            onSave={handleSave}
            entityName="Supplier"
            testIdPrefix="bulk-sup"
          />
        </CardContent>
      </Card>
    </div>
  );
};

export default BulkSuppliers;
